// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/browser/lite/" + chunkId + "." + {"49":"99408e6da456208c991a","587":"47ee61cea7984eb06da2"}[chunkId] + ".js";
};